import { createFileRoute, redirect } from '@tanstack/react-router';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Card, CardContent } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

export const Route = createFileRoute('/reports/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: ReportsPage,
});

function ReportsPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            التقارير / Rapports
          </h1>
          <p className="mt-2 text-gray-600">
            تقارير وتحليلات مفصلة / Rapports et analyses détaillés
          </p>
        </div>

        <Card className="border-0 shadow-sm">
          <CardContent className="p-12 text-center">
            <BarChart3 className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              قريباً / Bientôt disponible
            </h3>
            <p className="text-gray-600">
              نحن نعمل على هذه الميزة / Nous travaillons sur cette fonctionnalité
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
